import { Injectable } from '@angular/core';
import { GetResponse } from '@vi-iot/client/models';
import { Observable } from 'rxjs';
import { VerifyGatewayResponse } from '../../../../app/@store';

import { ClientService } from '../../client.service';
import { ActiveErrorResponse } from '../equipment/equipment.model';

@Injectable()
export class GatewayApi {
  constructor(private clientService: ClientService) {}

  /**
   * Returns a smart notes based on gateway serial.
   * @param gatewaySerial
   */
  getGatewaySmartNotes(gatewaySerial: string): Observable<GetResponse<ActiveErrorResponse[]>> {
    const endpoint = `iot/v1/smart-notes/gateways/${gatewaySerial}/smartNotes`;

    return this.clientService.get(endpoint);
  }

  /**
   * Returns a data of the gateway based on gateway serial and gateway password.
   * @param gatewaySerial
   * @param gatewayPassword gateway id, known as gateway backend password
   */
  verifyGateway(
    gatewaySerial: string,
    gatewayPassword: string
  ): Observable<GetResponse<VerifyGatewayResponse>> {
    const endpoint = `iot/v2/equipment/gateways/${gatewaySerial}/verify`;

    return this.clientService.post(endpoint, {
      password: gatewayPassword,
    });
  }
}
